import React, { SyntheticEvent } from 'react';

import { required } from 'react-admin';
import { Controller, useFormContext } from 'react-hook-form';
import { Button } from 'shared/mui/Buttons';
import { FormControlLabel } from 'shared/mui/FormControlLabel/FormControlLabel';
import { Switch } from 'shared/mui/Switch';

import { BoxStyled, CardStyled, TextInputStyled } from './CommissionsCreateLadderStep.styled';
import { CommissionStepFormValues } from '../CommissionsCreateForm';

type Props = {
  stepIndex: number;
  onRemoveStepClick: (index: number) => void;
};

export const CommissionsCreateLadderStep: React.FC<Props> = ({ stepIndex, onRemoveStepClick }) => {
  const { setValue, control, clearErrors, watch } = useFormContext();
  const stepPath = `ladder.steps.${stepIndex}` as const;

  const stepsWatched: CommissionStepFormValues[] | undefined = watch('ladder.steps') ?? undefined;
  const thresholdToWatched = watch(`${stepPath}.thresholdTo`);

  const stepsLength = stepsWatched?.length ?? 0;
  const lastStepIndex = stepsWatched?.findIndex((step) => step?.isLastStep) ?? -1;

  const onSetLastStepIndex = (_: SyntheticEvent, checked: boolean) => {
    if (checked) {
      clearErrors(`${stepPath}.thresholdTo`);
      setValue(`${stepPath}.thresholdTo`, null);
    }
  };

  return (
    <CardStyled key={stepIndex}>
      <BoxStyled>
        <TextInputStyled
          label="Порог от"
          source={`${stepPath}.thresholdFrom`}
          validate={required()}
          variant="outlined"
        />
        <TextInputStyled
          disabled={lastStepIndex === stepIndex}
          label="Порог до (включительно)"
          source={`${stepPath}.thresholdTo`}
          validate={required()}
          variant="outlined"
        />
        <TextInputStyled
          label="Процент"
          source={`${stepPath}.commissionRate.percent`}
          validate={required()}
          variant="outlined"
        />
        <TextInputStyled
          label="Фиксированная"
          source={`${stepPath}.commissionRate.fix`}
          variant="outlined"
        />
        <TextInputStyled
          label="Максимальная"
          source={`${stepPath}.commissionRate.max`}
          variant="outlined"
        />
        <TextInputStyled
          label="Минимальная"
          source={`${stepPath}.commissionRate.min`}
          variant="outlined"
        />
      </BoxStyled>
      <Controller
        control={control}
        name={`${stepPath}.isLastStep`}
        render={({ field: { onChange, value } }) => (
          <FormControlLabel
            control={<Switch size="small" />}
            disabled={
              (lastStepIndex !== -1 && lastStepIndex !== stepIndex) ||
              stepIndex < stepsLength - 1 ||
              !!thresholdToWatched
            }
            label="Последняя ступень"
            onChange={(event, checked) => {
              onChange(event);
              onSetLastStepIndex(event, checked);
            }}
            sx={{ margin: 0, marginBottom: '16px' }}
            value={value}
          />
        )}
      />

      <Button
        color="error"
        label="Удалить ступень"
        onClick={() => onRemoveStepClick(stepIndex)}
        variant="outlined"
      />
    </CardStyled>
  );
};
